import { camelCase, upperFirst } from 'lodash-es';
import wrap from 'word-wrap';
const wrapComment = (input = '') => {
    if (!input) {
        return [];
    }
    return wrap(input, { width: 80, indent: '// ' }).split('\n');
};
const indent = (input) => `  ${input}`;
const pascalCase = (input) => upperFirst(camelCase(input));
export { indent, pascalCase, wrapComment };
//# sourceMappingURL=strings.js.map